import { RouteConfig } from 'vue-router'

const Edit = () => import('../views/feedback/Edit.vue')

export const feedbackEditRoute: RouteConfig = {
  path: '/feedback/edit',
  name: 'feedback_edit',
  component: Edit,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '意见反馈',
  },
}

export default [feedbackEditRoute]
